import { getStore } from '@/store'
import { EMPTIES_TRANSPORTATIONS, mapTransportType } from '@/utils/transportTypes'

export function isWhsUser (): boolean {
  return localStorage.getItem('customertype') === 'WHSL'
}

export function isPosUser (): boolean {
  return localStorage.getItem('customertype') === 'POS'
}

export function showSuggestedCart (): boolean {
  const ArrayPermis = getStore()?.state.auth.user.permissionSchema ?? []
  const shipToId = localStorage.getItem('shipToId')
  const permissionScheme = ArrayPermis.find((item: any) => item.shipToId === shipToId)
  const isEligibleForSuggestedCart = permissionScheme?.rpDetails?.some((rp: any) => rp.permission === 'Suggested Cart')
  const suggestedCarts = getStore()?.state.basket.suggestedCarts
  const shipmentId = getStore()?.state.basket.shipmentId ?? localStorage.getItem('shippingMethod') ?? ''

  return !!((suggestedCarts?.[0]?.shipping_address?.sap_id) &&
    !EMPTIES_TRANSPORTATIONS.includes(mapTransportType(shipmentId)) && isEligibleForSuggestedCart)
}
